// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"667":"2755ce88","977":"afdc6592"}[chunkId] + ".chunk.js";
};